import { render, staticRenderFns } from "./Cloner.vue?vue&type=template&id=12801df4&"
import script from "./Cloner.vue?vue&type=script&lang=js&"
export * from "./Cloner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports